const getPharamcyAttachmentEnum = () => {
    return PharamcyAttachmentEnum;
}


let PharamcyAttachmentEnum = {
    VM_Pharmacy: 1,
    CPOE: 2,
    LAB: 3,
    RAD: 4,
    Cardiology: 5,
    MPI: 6
};


export {
    getPharamcyAttachmentEnum,
};